module.exports = __webpack_public_path__ + "static/media/lapresse-logo.7f871bef.png";